import { palette } from '@livable/saas-react-components';
const MuiInputLabel = {
  styleOverrides: {
    root: {
      fontSize: '18px',
      lineHeight: '24px',
      color: palette.shades[700],
      transform: 'translate(12px, 12px) scale(1)',
      '&.Mui-error': {
        color: palette.shades[700]
      },
      '&.Mui-disabled': {
        color: palette.shades[600]
      }
    },
    shrink: {
      transform: 'translate(12px, -9px) scale(0.75) !important',
      '&.Mui-error': {
        color: palette.error.main
      }
    },
    sizeSmall: {
      transform: 'translate(12px, 6px) scale(1)'
    }
  }
};
export default MuiInputLabel;